import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function InfoCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.937 6.06293 22.75 12 22.75C17.937 22.75 22.75 17.937 22.75 12C22.75 6.06293 17.937 1.25 12 1.25ZM13.0935 10.4884C12.8087 10.1752 12.4605 10.0702 12.1949 10.0309C11.9835 9.99964 11.739 9.99983 11.5408 9.99999L11.5 10C10.9477 10 10.5 10.4477 10.5 11C10.5 11.5523 10.9477 12 11.5 12V12.1V16.5C11.5 17.0523 11.9477 17.5 12.5 17.5C13.0523 17.5 13.5 17.0523 13.5 16.5V12.1V12.0602C13.5001 11.8365 13.5002 11.5871 13.4743 11.3752C13.4444 11.1308 13.3659 10.7881 13.0935 10.4884ZM12 9C12.6904 9 13.25 8.44036 13.25 7.75C13.25 7.05964 12.6904 6.5 12 6.5C11.3096 6.5 10.75 7.05964 10.75 7.75C10.75 8.44036 11.3096 9 12 9Z"
				fill="currentColor"
			/>
		</svg>
	);
}

InfoCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default InfoCircleFilledIcon;
